import React from 'react'
import { useTranslation } from 'react-i18next'

import Icon from '../../components/Icon'

import { VALVE_BADGE_SYMBOLS, getValveStateBadge } from './markerColors'

const TRANSLATION_KEYS = {
  open_failed: 'map:valveFailure.open',
  close_failed: 'map:valveFailure.close',
}

const ICON_NAMES = {
  [VALVE_BADGE_SYMBOLS.FAILURE]: 'exclamation-triangle',
  [VALVE_BADGE_SYMBOLS.PENDING]: 'hourglass-half',
}

// Warning symbol for a valve that did not open (orange) or did not close (yellow),
// hourglass (green) for an opened valve that is still waiting for pressure
const ValveFailureIcon = ({ inputMismatch, inputPending }) => {
  const { t } = useTranslation()
  const badge = getValveStateBadge({ inputMismatch, inputPending })

  if (!badge) {
    return null
  }

  const label =
    badge.symbol === VALVE_BADGE_SYMBOLS.PENDING
      ? t('map:valveFailure.pending')
      : t(TRANSLATION_KEYS[inputMismatch])
  return (
    <Icon
      small
      bordered={false}
      name={ICON_NAMES[badge.symbol]}
      color={badge.color}
      title={label}
      aria-label={label}
      role="img"
    />
  )
}

export default ValveFailureIcon
